import styled from 'styled-components';

const FavoritePageIndicator = styled.div`
  color: white;
  width: 200px;
`;

export default FavoritePageIndicator;
